import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "editTime"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  style: {
    "padding": "14px"
  }
};
const _hoisted_5 = {
  class: "bottom"
};
const _hoisted_6 = {
  class: "tab_time"
};
import { StarFilled } from '@element-plus/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { onMounted, ref, watchEffect } from 'vue';
import moment from 'moment';
export default {
  __name: 'New',
  setup(__props) {
    moment.locale('zh-cn');
    const route = useRoute();
    const router = useRouter();
    const currentNews = ref({});
    const newstop4 = ref([]);
    const waterMark = ref(null);
    const domSymbol = Symbol("watermark-dom");
    const id = domSymbol.toString();
    const domId = document.getElementById(id);
    watchEffect(async () => {
      if (!route.params.id) return;
      // 获取路由参数：
      // console.log(route.params.id)
      const res1 = await axios.get(`/webapi/news/list/${route.params.id}`);
      // console.log(res1.data.data[0])
      // 获取新闻的前四条数据：
      const res2 = await axios.get(`/webapi/news/toplist/?limit=4`);
      // console.log(res2.data.data)
      currentNews.value = res1.data.data[0];
      newstop4.value = res2.data.data;
    });
    const formatTime = time => {
      return moment(time).format('lll');
    };
    const handleChangePage = id => {
      console.log(id);
      router.push(`/news/${id}`);
    };

    // const clear = ()=>{
    // const func = ()=>{}
    //     if (domId) {
    //       const el = waterMark.value
    //       el && el.removeChild(domId)
    //     }
    //     window.removeEventListener('resize', func)
    //   }

    const createWaterMark = appendEl => {
      const can = document.createElement('canvas');
      can.width = 300;
      can.height = 240;
      const str = "方允科技";
      const cans = can.getContext('2d');
      if (cans) {
        cans.rotate(-20 * Math.PI / 120);
        cans.font = '16px Vedana';
        cans.fillStyle = 'rgba(0, 0, 0, 0.35)';
        cans.textAlign = 'left';
        cans.textBaseline = 'middle';
        cans.fillText(str, can.width / 20, can.height);
      }
      const div = document.createElement('div');
      div.id = id;
      div.style.pointerEvents = 'none';
      div.style.top = '0px';
      div.style.left = '0px';
      div.style.position = 'absolute';
      div.style.zIndex = '100000000';
      div.style.width = document.documentElement.clientWidth + 'px';
      div.style.height = document.documentElement.clientHeight + 'px';
      div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
      const el = appendEl;
      el && el.appendChild(div);

      // return id
    };
    onMounted(() => {
      // clear()
      createWaterMark(waterMark.value);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createBlock(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 17,
          offset: 1
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            ref_key: "waterMark",
            ref: waterMark
          }, [_createElementVNode("h2", null, _toDisplayString(currentNews.value.title), 1), _createElementVNode("div", _hoisted_1, _toDisplayString(currentNews.value.editTime), 1), _createVNode(_component_el_divider, null, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(StarFilled))]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", {
            innerHTML: currentNews.value.content
          }, null, 8, _hoisted_2)], 512)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5,
          offset: 1,
          pull: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            class: "box-card"
          }, {
            header: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
              class: "card-header"
            }, [_createElementVNode("span", {
              style: {
                "font-size": "17px",
                "font-weight": "700"
              }
            }, "最新新闻")], -1)]))]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newstop4.value, item => {
              return _openBlock(), _createElementBlock("div", {
                key: item._id,
                class: "text item",
                onClick: $event => handleChangePage(item._id)
              }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("time", _hoisted_6, _toDisplayString(formatTime(item.editTime)), 1)])])], 8, _hoisted_3);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};